import { userConstants } from "../constants/index";
import { userService } from "../../services";
import { Cookies } from "react-cookie";
import { cookieConstants } from "../constants/";
import { history } from "../../config/History";
import { setCookieExpireDate } from "../../utils/CustomCookies";
import { panelRoutes } from "../../Routes/routes";
export const userActions = {
  login,
  logout,
  usersList,
  addUser,
  getUser,
  updateUser,
};

const cookies = new Cookies();

/*
ACTION: Login
*/
function login(username, password, gRecaptchaResponse, addToast) {
  return (dispatch) => {
    dispatch(request());
    userService.login(username, password, gRecaptchaResponse).then(
      (user) => {
        addToast("ورود با موفقیت انجام شد", {
          appearance: "success",
          autoDismiss: true,
        });
        const jwt_token = user.data.body.token;
        const userData =
          user.data.body.profile && user.data.body.profile.length > 0
            ? user.data.body.profile[0]
            : {};
        cookies.set(cookieConstants.USER, userData, {
          expires: setCookieExpireDate(),
          path: "/",
        });
        cookies.set(cookieConstants.TOKEN, jwt_token, {
          expires: setCookieExpireDate(),
          path: "/",
        });
        dispatch(success(userData));
        history.push(panelRoutes.DASHBOARD.path);
      },
      (error) => {
        if (typeof error === "object") {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

/*
ACTION: Users List
*/
function usersList(pageID, perPage, searchInput = "", role = "") {
  return (dispatch) => {
    dispatch(request());
    return userService.usersList(pageID, perPage, searchInput, role).then(
      (response) => {
        console.log(response);
        dispatch(
          success(response.data.body.users, response.data.body.data.total)
        );
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(items, total) {
    return { type: userConstants.GETALL_SUCCESS, items, total };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

/*
ACTION: Add User
*/
function addUser(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return userService.addUser(formData).then(
      (response) => {
        addToast("عملیات با موفقیت انجام شد.", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === "object") {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userConstants.ADD_REQUEST };
  }
  function success(status) {
    return { type: userConstants.ADD_SUCCESS, status };
  }
  function failure(error) {
    return { type: userConstants.ADD_FAILURE, error };
  }
}

/*
ACTION: Get User By ID
*/
function getUser() {
  return (dispatch) => {
    dispatch(request());
    return userService.getUser().then(
      (response) => {
        const body = response.data.body;
        const profile = body.profile || body;
        dispatch(success(Array.isArray(profile) ? profile[0] : profile));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userConstants.GET_REQUEST };
  }
  function success(item) {
    return { type: userConstants.GET_SUCCESS, item };
  }
  function failure(error) {
    return { type: userConstants.GET_FAILURE, error };
  }
}

/*
ACTION: Update User
*/
function updateUser(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return userService.updateUser(formData).then(
      (response) => {
        addToast("بروزرسانی با موفقیت انجام شد.", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === "object") {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        } else {
          addToast("خطا در برقراری اتصال با سرور!", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: userConstants.UPDATE_REQUEST };
  }
  function success(status) {
    return { type: userConstants.UPDATE_SUCCESS, status };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_FAILURE, error };
  }
}
